// extracted by mini-css-extract-plugin
export default {"overlay":"gA-z","bodyOpen":"hA-z","content":"iA-z","header":"jA-z","close":"kA-z","closeNoHeading":"lA-z"};